import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { commonTestIds } from '../../../../common/utils/commonTestIds';
import { EventCategory } from '../../../../common/utils/googleAnalyticsConstants';
import { executeIfLoggedIn } from '../../../../common/utils/logonUtils';
import OrderViewerApiService from '../../api/orderViewerApiService';
import { IOrderViewerMainStore } from '../../typing/stores';
import RedirectHelper from '../../utils/redirectHelper';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';

interface IEnrichButton {
	orderId?: number;
	userId?: number;
	documentId?: number;
	documentViewerLogonURL?: string;
	orderViewerApiService?: OrderViewerApiService;
	redirectHelper?: RedirectHelper;
}

const EnrichButton: React.FunctionComponent<IEnrichButton & IActionButtonCommonProps> = props => {
	const doEnrichment = () => {
		executeIfLoggedIn(() => {
			props.redirectHelper.redirectToEnrichment(props.documentId);
		}, props.documentViewerLogonURL);
	};

	const handler = async () => {
		if (!props.orderId || !props.userId) {
			return;
		}

		gaLogAction(EventCategory.DocViewer, 'EnrichDocument', 'Enrich document', `orderId: ${props.orderId}`);
		if (props.documentId && props.documentId > 0) {
			doEnrichment();
		}

		const status = await props.orderViewerApiService.getDocEnrichmentStatusAsync(props.orderId, props.userId);
		const docId = status.docId;

		if (docId && docId != 0 && status.canEnrich) {
			doEnrichment();
		} else if (!status.canEnrich) {
			alert(Prompts.DocEnrichNotAble);
		} else {
			alert(Prompts.DocEnrichNotReady);
		}
	};

	return (
		<ActionButton
			label={localize('Enrich document')}
			handler={handler}
			icon={Icons.DocumentIcon}
			isPrimary={props.isPrimary}
			testId={commonTestIds.enrichBtn}
			controlledBy={props.controlledBy}
		/>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	orderId: stores.orderViewerStore.viewModel.orderId,
	userId: stores.orderViewerStore.viewModel.userId,
	documentId: stores.orderViewerStore.viewModel.documentModel.documentId,
	documentViewerLogonURL: stores.orderViewerStore.viewModel.documentLogonViewerUrl.logonUrl,
	orderViewerApiService: stores.api.orderViewerApiService,
	redirectHelper: stores.redirectHelper
}))(EnrichButton);
